module.exports = __webpack_public_path__ + "img/cdr.ae3a0870.svg";